module.exports = __webpack_public_path__ + "img/expression8.c82e5966.png";